// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib/iconBase';
export var FiActivity = function FiActivity(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    }]
  })(props);
};
FiActivity.displayName = "FiActivity";
export var FiAirplay = function FiAirplay(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "12 15 17 21 7 21 12 15"
      }
    }]
  })(props);
};
FiAirplay.displayName = "FiAirplay";
export var FiAlertCircle = function FiAlertCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
};
FiAlertCircle.displayName = "FiAlertCircle";
export var FiAlertOctagon = function FiAlertOctagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
};
FiAlertOctagon.displayName = "FiAlertOctagon";
export var FiAlertTriangle = function FiAlertTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "17"
      }
    }]
  })(props);
};
FiAlertTriangle.displayName = "FiAlertTriangle";
export var FiAlignCenter = function FiAlignCenter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "10",
        "x2": "6",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "6",
        "x2": "3",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "14",
        "x2": "3",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "6",
        "y2": "18"
      }
    }]
  })(props);
};
FiAlignCenter.displayName = "FiAlignCenter";
export var FiAlignJustify = function FiAlignJustify(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "10",
        "x2": "3",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "6",
        "x2": "3",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "14",
        "x2": "3",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "18",
        "x2": "3",
        "y2": "18"
      }
    }]
  })(props);
};
FiAlignJustify.displayName = "FiAlignJustify";
export var FiAlignLeft = function FiAlignLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "10",
        "x2": "3",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "6",
        "x2": "3",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "14",
        "x2": "3",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "18",
        "x2": "3",
        "y2": "18"
      }
    }]
  })(props);
};
FiAlignLeft.displayName = "FiAlignLeft";
export var FiAlignRight = function FiAlignRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "10",
        "x2": "7",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "6",
        "x2": "3",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "14",
        "x2": "3",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "18",
        "x2": "7",
        "y2": "18"
      }
    }]
  })(props);
};
FiAlignRight.displayName = "FiAlignRight";
export var FiAnchor = function FiAnchor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22",
        "x2": "12",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12H2a10 10 0 0 0 20 0h-3"
      }
    }]
  })(props);
};
FiAnchor.displayName = "FiAnchor";
export var FiAperture = function FiAperture(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.31",
        "y1": "8",
        "x2": "20.05",
        "y2": "17.94"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.69",
        "y1": "8",
        "x2": "21.17",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.38",
        "y1": "12",
        "x2": "13.12",
        "y2": "2.06"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.69",
        "y1": "16",
        "x2": "3.95",
        "y2": "6.06"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.31",
        "y1": "16",
        "x2": "2.83",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.62",
        "y1": "12",
        "x2": "10.88",
        "y2": "21.94"
      }
    }]
  })(props);
};
FiAperture.displayName = "FiAperture";
export var FiArchive = function FiArchive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "21 8 21 21 3 21 3 8"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "3",
        "width": "22",
        "height": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }]
  })(props);
};
FiArchive.displayName = "FiArchive";
export var FiArrowDownCircle = function FiArrowDownCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 12 12 16 16 12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
};
FiArrowDownCircle.displayName = "FiArrowDownCircle";
export var FiArrowDownLeft = function FiArrowDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "7",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 17 7 17 7 7"
      }
    }]
  })(props);
};
FiArrowDownLeft.displayName = "FiArrowDownLeft";
export var FiArrowDownRight = function FiArrowDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "17",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 7 17 17 7 17"
      }
    }]
  })(props);
};
FiArrowDownRight.displayName = "FiArrowDownRight";
export var FiArrowDown = function FiArrowDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "19 12 12 19 5 12"
      }
    }]
  })(props);
};
FiArrowDown.displayName = "FiArrowDown";
export var FiArrowLeftCircle = function FiArrowLeftCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 8 8 12 12 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "8",
        "y2": "12"
      }
    }]
  })(props);
};
FiArrowLeftCircle.displayName = "FiArrowLeftCircle";
export var FiArrowLeft = function FiArrowLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "5",
        "y2": "12"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 19 5 12 12 5"
      }
    }]
  })(props);
};
FiArrowLeft.displayName = "FiArrowLeft";
export var FiArrowRightCircle = function FiArrowRightCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 16 16 12 12 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiArrowRightCircle.displayName = "FiArrowRightCircle";
export var FiArrowRight = function FiArrowRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 5 19 12 12 19"
      }
    }]
  })(props);
};
FiArrowRight.displayName = "FiArrowRight";
export var FiArrowUpCircle = function FiArrowUpCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 12 12 8 8 12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "8"
      }
    }]
  })(props);
};
FiArrowUpCircle.displayName = "FiArrowUpCircle";
export var FiArrowUpLeft = function FiArrowUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "7",
        "y2": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 17 7 7 17 7"
      }
    }]
  })(props);
};
FiArrowUpLeft.displayName = "FiArrowUpLeft";
export var FiArrowUpRight = function FiArrowUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "17",
        "x2": "17",
        "y2": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 7 17 7 17 17"
      }
    }]
  })(props);
};
FiArrowUpRight.displayName = "FiArrowUpRight";
export var FiArrowUp = function FiArrowUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 12 12 5 19 12"
      }
    }]
  })(props);
};
FiArrowUp.displayName = "FiArrowUp";
export var FiAtSign = function FiAtSign(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
      }
    }]
  })(props);
};
FiAtSign.displayName = "FiAtSign";
export var FiAward = function FiAward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "8",
        "r": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
      }
    }]
  })(props);
};
FiAward.displayName = "FiAward";
export var FiBarChart2 = function FiBarChart2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "20",
        "x2": "18",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "20",
        "x2": "6",
        "y2": "14"
      }
    }]
  })(props);
};
FiBarChart2.displayName = "FiBarChart2";
export var FiBarChart = function FiBarChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "20",
        "x2": "18",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "20",
        "x2": "6",
        "y2": "16"
      }
    }]
  })(props);
};
FiBarChart.displayName = "FiBarChart";
export var FiBatteryCharging = function FiBatteryCharging(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "13",
        "x2": "23",
        "y2": "11"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "11 6 7 12 13 12 9 18"
      }
    }]
  })(props);
};
FiBatteryCharging.displayName = "FiBatteryCharging";
export var FiBattery = function FiBattery(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "6",
        "width": "18",
        "height": "12",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "13",
        "x2": "23",
        "y2": "11"
      }
    }]
  })(props);
};
FiBattery.displayName = "FiBattery";
export var FiBellOff = function FiBellOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M8.56 2.9A7 7 0 0 1 19 9v4m-2 4H2a3 3 0 0 0 3-3V9a7 7 0 0 1 .78-3.22M13.73 21a2 2 0 0 1-3.46 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiBellOff.displayName = "FiBellOff";
export var FiBell = function FiBell(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"
      }
    }]
  })(props);
};
FiBell.displayName = "FiBell";
export var FiBluetooth = function FiBluetooth(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
      }
    }]
  })(props);
};
FiBluetooth.displayName = "FiBluetooth";
export var FiBold = function FiBold(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
      }
    }]
  })(props);
};
FiBold.displayName = "FiBold";
export var FiBookOpen = function FiBookOpen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
      }
    }]
  })(props);
};
FiBookOpen.displayName = "FiBookOpen";
export var FiBook = function FiBook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
      }
    }]
  })(props);
};
FiBook.displayName = "FiBook";
export var FiBookmark = function FiBookmark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
      }
    }]
  })(props);
};
FiBookmark.displayName = "FiBookmark";
export var FiBox = function FiBox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "2.32 6.16 12 11 21.68 6.16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22.76",
        "x2": "12",
        "y2": "11"
      }
    }]
  })(props);
};
FiBox.displayName = "FiBox";
export var FiBriefcase = function FiBriefcase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "14",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
      }
    }]
  })(props);
};
FiBriefcase.displayName = "FiBriefcase";
export var FiCalendar = function FiCalendar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
};
FiCalendar.displayName = "FiCalendar";
export var FiCameraOff = function FiCameraOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
      }
    }]
  })(props);
};
FiCameraOff.displayName = "FiCameraOff";
export var FiCamera = function FiCamera(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "4"
      }
    }]
  })(props);
};
FiCamera.displayName = "FiCamera";
export var FiCast = function FiCast(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "20",
        "x2": "2",
        "y2": "20"
      }
    }]
  })(props);
};
FiCast.displayName = "FiCast";
export var FiCheckCircle = function FiCheckCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22 4 12 14.01 9 11.01"
      }
    }]
  })(props);
};
FiCheckCircle.displayName = "FiCheckCircle";
export var FiCheckSquare = function FiCheckSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 11 12 14 22 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
      }
    }]
  })(props);
};
FiCheckSquare.displayName = "FiCheckSquare";
export var FiCheck = function FiCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "20 6 9 17 4 12"
      }
    }]
  })(props);
};
FiCheck.displayName = "FiCheck";
export var FiChevronDown = function FiChevronDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "6 9 12 15 18 9"
      }
    }]
  })(props);
};
FiChevronDown.displayName = "FiChevronDown";
export var FiChevronLeft = function FiChevronLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 18 9 12 15 6"
      }
    }]
  })(props);
};
FiChevronLeft.displayName = "FiChevronLeft";
export var FiChevronRight = function FiChevronRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 18 15 12 9 6"
      }
    }]
  })(props);
};
FiChevronRight.displayName = "FiChevronRight";
export var FiChevronUp = function FiChevronUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "18 15 12 9 6 15"
      }
    }]
  })(props);
};
FiChevronUp.displayName = "FiChevronUp";
export var FiChevronsDown = function FiChevronsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "7 13 12 18 17 13"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 6 12 11 17 6"
      }
    }]
  })(props);
};
FiChevronsDown.displayName = "FiChevronsDown";
export var FiChevronsLeft = function FiChevronsLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "11 17 6 12 11 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "18 17 13 12 18 7"
      }
    }]
  })(props);
};
FiChevronsLeft.displayName = "FiChevronsLeft";
export var FiChevronsRight = function FiChevronsRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "13 17 18 12 13 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "6 17 11 12 6 7"
      }
    }]
  })(props);
};
FiChevronsRight.displayName = "FiChevronsRight";
export var FiChevronsUp = function FiChevronsUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "17 11 12 6 7 11"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 18 12 13 7 18"
      }
    }]
  })(props);
};
FiChevronsUp.displayName = "FiChevronsUp";
export var FiChrome = function FiChrome(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21.17",
        "y1": "8",
        "x2": "12",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.95",
        "y1": "6.06",
        "x2": "8.54",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10.88",
        "y1": "21.94",
        "x2": "15.46",
        "y2": "14"
      }
    }]
  })(props);
};
FiChrome.displayName = "FiChrome";
export var FiCircle = function FiCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }]
  })(props);
};
FiCircle.displayName = "FiCircle";
export var FiClipboard = function FiClipboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "2",
        "width": "8",
        "height": "4",
        "rx": "1",
        "ry": "1"
      }
    }]
  })(props);
};
FiClipboard.displayName = "FiClipboard";
export var FiClock = function FiClock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 6 12 12 16 14"
      }
    }]
  })(props);
};
FiClock.displayName = "FiClock";
export var FiCloudDrizzle = function FiCloudDrizzle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "19",
        "x2": "8",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "8",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "19",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "13",
        "x2": "16",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
      }
    }]
  })(props);
};
FiCloudDrizzle.displayName = "FiCloudDrizzle";
export var FiCloudLightning = function FiCloudLightning(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 11 9 17 15 17 11 23"
      }
    }]
  })(props);
};
FiCloudLightning.displayName = "FiCloudLightning";
export var FiCloudOff = function FiCloudOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiCloudOff.displayName = "FiCloudOff";
export var FiCloudRain = function FiCloudRain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "13",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "8",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
      }
    }]
  })(props);
};
FiCloudRain.displayName = "FiCloudRain";
export var FiCloudSnow = function FiCloudSnow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "16",
        "x2": "8",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "16",
        "x2": "16",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20"
      }
    }]
  })(props);
};
FiCloudSnow.displayName = "FiCloudSnow";
export var FiCloud = function FiCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
      }
    }]
  })(props);
};
FiCloud.displayName = "FiCloud";
export var FiCode = function FiCode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "16 18 22 12 16 6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 6 2 12 8 18"
      }
    }]
  })(props);
};
FiCode.displayName = "FiCode";
export var FiCodepen = function FiCodepen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22",
        "x2": "12",
        "y2": "15.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22 8.5 12 15.5 2 8.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "2 15.5 12 8.5 22 15.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "8.5"
      }
    }]
  })(props);
};
FiCodepen.displayName = "FiCodepen";
export var FiCommand = function FiCommand(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
      }
    }]
  })(props);
};
FiCommand.displayName = "FiCommand";
export var FiCompass = function FiCompass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
      }
    }]
  })(props);
};
FiCompass.displayName = "FiCompass";
export var FiCopy = function FiCopy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "9",
        "width": "13",
        "height": "13",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
      }
    }]
  })(props);
};
FiCopy.displayName = "FiCopy";
export var FiCornerDownLeft = function FiCornerDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 10 4 15 9 20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v7a4 4 0 0 1-4 4H4"
      }
    }]
  })(props);
};
FiCornerDownLeft.displayName = "FiCornerDownLeft";
export var FiCornerDownRight = function FiCornerDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 10 20 15 15 20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v7a4 4 0 0 0 4 4h12"
      }
    }]
  })(props);
};
FiCornerDownRight.displayName = "FiCornerDownRight";
export var FiCornerLeftDown = function FiCornerLeftDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "14 15 9 20 4 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4h-7a4 4 0 0 0-4 4v12"
      }
    }]
  })(props);
};
FiCornerLeftDown.displayName = "FiCornerLeftDown";
export var FiCornerLeftUp = function FiCornerLeftUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "14 9 9 4 4 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-7a4 4 0 0 1-4-4V4"
      }
    }]
  })(props);
};
FiCornerLeftUp.displayName = "FiCornerLeftUp";
export var FiCornerRightDown = function FiCornerRightDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "10 15 15 20 20 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4h7a4 4 0 0 1 4 4v12"
      }
    }]
  })(props);
};
FiCornerRightDown.displayName = "FiCornerRightDown";
export var FiCornerRightUp = function FiCornerRightUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "10 9 15 4 20 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h7a4 4 0 0 0 4-4V4"
      }
    }]
  })(props);
};
FiCornerRightUp.displayName = "FiCornerRightUp";
export var FiCornerUpLeft = function FiCornerUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 14 4 9 9 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20v-7a4 4 0 0 0-4-4H4"
      }
    }]
  })(props);
};
FiCornerUpLeft.displayName = "FiCornerUpLeft";
export var FiCornerUpRight = function FiCornerUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 14 20 9 15 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-7a4 4 0 0 1 4-4h12"
      }
    }]
  })(props);
};
FiCornerUpRight.displayName = "FiCornerUpRight";
export var FiCpu = function FiCpu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "9",
        "width": "6",
        "height": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "1",
        "x2": "9",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "1",
        "x2": "15",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "20",
        "x2": "9",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "20",
        "x2": "15",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "9",
        "x2": "23",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "14",
        "x2": "23",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "9",
        "x2": "4",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "14",
        "x2": "4",
        "y2": "14"
      }
    }]
  })(props);
};
FiCpu.displayName = "FiCpu";
export var FiCreditCard = function FiCreditCard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "4",
        "width": "22",
        "height": "16",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "10",
        "x2": "23",
        "y2": "10"
      }
    }]
  })(props);
};
FiCreditCard.displayName = "FiCreditCard";
export var FiCrop = function FiCrop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M6.13 1L6 16a2 2 0 0 0 2 2h15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M1 6.13L16 6a2 2 0 0 1 2 2v15"
      }
    }]
  })(props);
};
FiCrop.displayName = "FiCrop";
export var FiCrosshair = function FiCrosshair(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "22",
        "y1": "12",
        "x2": "18",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "2",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22",
        "x2": "12",
        "y2": "18"
      }
    }]
  })(props);
};
FiCrosshair.displayName = "FiCrosshair";
export var FiDatabase = function FiDatabase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "5",
        "rx": "9",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
      }
    }]
  })(props);
};
FiDatabase.displayName = "FiDatabase";
export var FiDelete = function FiDelete(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "9",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "18",
        "y2": "15"
      }
    }]
  })(props);
};
FiDelete.displayName = "FiDelete";
export var FiDisc = function FiDisc(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
};
FiDisc.displayName = "FiDisc";
export var FiDollarSign = function FiDollarSign(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "1",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
      }
    }]
  })(props);
};
FiDollarSign.displayName = "FiDollarSign";
export var FiDownloadCloud = function FiDownloadCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "8 17 12 21 16 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
      }
    }]
  })(props);
};
FiDownloadCloud.displayName = "FiDownloadCloud";
export var FiDownload = function FiDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 10 12 15 17 10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "3"
      }
    }]
  })(props);
};
FiDownload.displayName = "FiDownload";
export var FiDroplet = function FiDroplet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
      }
    }]
  })(props);
};
FiDroplet.displayName = "FiDroplet";
export var FiEdit2 = function FiEdit2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "16 3 21 8 8 21 3 21 3 16 16 3"
      }
    }]
  })(props);
};
FiEdit2.displayName = "FiEdit2";
export var FiEdit3 = function FiEdit3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "14 2 18 6 7 17 3 17 3 13 14 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "22",
        "x2": "21",
        "y2": "22"
      }
    }]
  })(props);
};
FiEdit3.displayName = "FiEdit3";
export var FiEdit = function FiEdit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "18 2 22 6 12 16 8 16 8 12 18 2"
      }
    }]
  })(props);
};
FiEdit.displayName = "FiEdit";
export var FiExternalLink = function FiExternalLink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 3 21 3 21 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "21",
        "y2": "3"
      }
    }]
  })(props);
};
FiExternalLink.displayName = "FiExternalLink";
export var FiEyeOff = function FiEyeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiEyeOff.displayName = "FiEyeOff";
export var FiEye = function FiEye(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
};
FiEye.displayName = "FiEye";
export var FiFacebook = function FiFacebook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
      }
    }]
  })(props);
};
FiFacebook.displayName = "FiFacebook";
export var FiFastForward = function FiFastForward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "13 19 22 12 13 5 13 19"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "2 19 11 12 2 5 2 19"
      }
    }]
  })(props);
};
FiFastForward.displayName = "FiFastForward";
export var FiFeather = function FiFeather(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "8",
        "x2": "2",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "15",
        "x2": "9",
        "y2": "15"
      }
    }]
  })(props);
};
FiFeather.displayName = "FiFeather";
export var FiFileMinus = function FiFileMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 2 14 8 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
};
FiFileMinus.displayName = "FiFileMinus";
export var FiFilePlus = function FiFilePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 2 14 8 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
};
FiFilePlus.displayName = "FiFilePlus";
export var FiFileText = function FiFileText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 2 14 8 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "13",
        "x2": "8",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "17",
        "x2": "8",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 9 9 9 8 9"
      }
    }]
  })(props);
};
FiFileText.displayName = "FiFileText";
export var FiFile = function FiFile(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 2 13 9 20 9"
      }
    }]
  })(props);
};
FiFile.displayName = "FiFile";
export var FiFilm = function FiFilm(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "2",
        "width": "20",
        "height": "20",
        "rx": "2.18",
        "ry": "2.18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "2",
        "x2": "7",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "2",
        "x2": "17",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "12",
        "x2": "22",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "7",
        "x2": "7",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "17",
        "x2": "7",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "22",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "22",
        "y2": "7"
      }
    }]
  })(props);
};
FiFilm.displayName = "FiFilm";
export var FiFilter = function FiFilter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
      }
    }]
  })(props);
};
FiFilter.displayName = "FiFilter";
export var FiFlag = function FiFlag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "22",
        "x2": "4",
        "y2": "15"
      }
    }]
  })(props);
};
FiFlag.displayName = "FiFlag";
export var FiFolderMinus = function FiFolderMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "14",
        "x2": "15",
        "y2": "14"
      }
    }]
  })(props);
};
FiFolderMinus.displayName = "FiFolderMinus";
export var FiFolderPlus = function FiFolderPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "11",
        "x2": "12",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "14",
        "x2": "15",
        "y2": "14"
      }
    }]
  })(props);
};
FiFolderPlus.displayName = "FiFolderPlus";
export var FiFolder = function FiFolder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
      }
    }]
  })(props);
};
FiFolder.displayName = "FiFolder";
export var FiGift = function FiGift(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "20 12 20 22 4 22 4 12"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22",
        "x2": "12",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
      }
    }]
  })(props);
};
FiGift.displayName = "FiGift";
export var FiGitBranch = function FiGitBranch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "3",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a9 9 0 0 1-9 9"
      }
    }]
  })(props);
};
FiGitBranch.displayName = "FiGitBranch";
export var FiGitCommit = function FiGitCommit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1.05",
        "y1": "12",
        "x2": "7",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17.01",
        "y1": "12",
        "x2": "22.96",
        "y2": "12"
      }
    }]
  })(props);
};
FiGitCommit.displayName = "FiGitCommit";
export var FiGitMerge = function FiGitMerge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21V9a9 9 0 0 0 9 9"
      }
    }]
  })(props);
};
FiGitMerge.displayName = "FiGitMerge";
export var FiGitPullRequest = function FiGitPullRequest(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 6h3a2 2 0 0 1 2 2v7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "9",
        "x2": "6",
        "y2": "21"
      }
    }]
  })(props);
};
FiGitPullRequest.displayName = "FiGitPullRequest";
export var FiGithub = function FiGithub(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
      }
    }]
  })(props);
};
FiGithub.displayName = "FiGithub";
export var FiGitlab = function FiGitlab(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
      }
    }]
  })(props);
};
FiGitlab.displayName = "FiGitlab";
export var FiGlobe = function FiGlobe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "12",
        "x2": "22",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
      }
    }]
  })(props);
};
FiGlobe.displayName = "FiGlobe";
export var FiGrid = function FiGrid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "3",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "14",
        "width": "7",
        "height": "7"
      }
    }]
  })(props);
};
FiGrid.displayName = "FiGrid";
export var FiHardDrive = function FiHardDrive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "22",
        "y1": "12",
        "x2": "2",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "16",
        "x2": "6",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "10",
        "y2": "16"
      }
    }]
  })(props);
};
FiHardDrive.displayName = "FiHardDrive";
export var FiHash = function FiHash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "9",
        "x2": "20",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "3",
        "x2": "8",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "14",
        "y2": "21"
      }
    }]
  })(props);
};
FiHash.displayName = "FiHash";
export var FiHeadphones = function FiHeadphones(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M3 18v-6a9 9 0 0 1 18 0v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
      }
    }]
  })(props);
};
FiHeadphones.displayName = "FiHeadphones";
export var FiHeart = function FiHeart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      }
    }]
  })(props);
};
FiHeart.displayName = "FiHeart";
export var FiHelpCircle = function FiHelpCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "17"
      }
    }]
  })(props);
};
FiHelpCircle.displayName = "FiHelpCircle";
export var FiHome = function FiHome(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 22 9 12 15 12 15 22"
      }
    }]
  })(props);
};
FiHome.displayName = "FiHome";
export var FiImage = function FiImage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": "1.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "21 15 16 10 5 21"
      }
    }]
  })(props);
};
FiImage.displayName = "FiImage";
export var FiInbox = function FiInbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "22 12 16 12 14 15 10 15 8 12 2 12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
      }
    }]
  })(props);
};
FiInbox.displayName = "FiInbox";
export var FiInfo = function FiInfo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8"
      }
    }]
  })(props);
};
FiInfo.displayName = "FiInfo";
export var FiInstagram = function FiInstagram(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "2",
        "width": "20",
        "height": "20",
        "rx": "5",
        "ry": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17.5",
        "y1": "6.5",
        "x2": "17.5",
        "y2": "6.5"
      }
    }]
  })(props);
};
FiInstagram.displayName = "FiInstagram";
export var FiItalic = function FiItalic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "4",
        "x2": "10",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "5",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "4",
        "x2": "9",
        "y2": "20"
      }
    }]
  })(props);
};
FiItalic.displayName = "FiItalic";
export var FiLayers = function FiLayers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "12 2 2 7 12 12 22 7 12 2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "2 17 12 22 22 17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "2 12 12 17 22 12"
      }
    }]
  })(props);
};
FiLayers.displayName = "FiLayers";
export var FiLayout = function FiLayout(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "21",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "21",
        "x2": "9",
        "y2": "9"
      }
    }]
  })(props);
};
FiLayout.displayName = "FiLayout";
export var FiLifeBuoy = function FiLifeBuoy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "9.17",
        "y2": "9.17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "14.83",
        "x2": "19.07",
        "y2": "19.07"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "19.07",
        "y2": "4.93"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "18.36",
        "y2": "5.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "19.07",
        "x2": "9.17",
        "y2": "14.83"
      }
    }]
  })(props);
};
FiLifeBuoy.displayName = "FiLifeBuoy";
export var FiLink2 = function FiLink2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiLink2.displayName = "FiLink2";
export var FiLink = function FiLink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
      }
    }]
  })(props);
};
FiLink.displayName = "FiLink";
export var FiLinkedin = function FiLinkedin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "9",
        "width": "4",
        "height": "12"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "4",
        "r": "2"
      }
    }]
  })(props);
};
FiLinkedin.displayName = "FiLinkedin";
export var FiList = function FiList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "18",
        "x2": "21",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "3",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "18",
        "x2": "3",
        "y2": "18"
      }
    }]
  })(props);
};
FiList.displayName = "FiList";
export var FiLoader = function FiLoader(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "7.76",
        "y2": "7.76"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.24",
        "y1": "16.24",
        "x2": "19.07",
        "y2": "19.07"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "12",
        "x2": "6",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "12",
        "x2": "22",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "19.07",
        "x2": "7.76",
        "y2": "16.24"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.24",
        "y1": "7.76",
        "x2": "19.07",
        "y2": "4.93"
      }
    }]
  })(props);
};
FiLoader.displayName = "FiLoader";
export var FiLock = function FiLock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "11",
        "width": "18",
        "height": "11",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11V7a5 5 0 0 1 10 0v4"
      }
    }]
  })(props);
};
FiLock.displayName = "FiLock";
export var FiLogIn = function FiLogIn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 17 15 12 10 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }]
  })(props);
};
FiLogIn.displayName = "FiLogIn";
export var FiLogOut = function FiLogOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 17 21 12 16 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "9",
        "y2": "12"
      }
    }]
  })(props);
};
FiLogOut.displayName = "FiLogOut";
export var FiMail = function FiMail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22,6 12,13 2,6"
      }
    }]
  })(props);
};
FiMail.displayName = "FiMail";
export var FiMapPin = function FiMapPin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    }]
  })(props);
};
FiMapPin.displayName = "FiMapPin";
export var FiMap = function FiMap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "6",
        "x2": "16",
        "y2": "22"
      }
    }]
  })(props);
};
FiMap.displayName = "FiMap";
export var FiMaximize2 = function FiMaximize2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 3 21 3 21 9"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 21 3 21 3 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "3",
        "x2": "14",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "10",
        "y2": "14"
      }
    }]
  })(props);
};
FiMaximize2.displayName = "FiMaximize2";
export var FiMaximize = function FiMaximize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
      }
    }]
  })(props);
};
FiMaximize.displayName = "FiMaximize";
export var FiMenu = function FiMenu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "18",
        "x2": "21",
        "y2": "18"
      }
    }]
  })(props);
};
FiMenu.displayName = "FiMenu";
export var FiMessageCircle = function FiMessageCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
      }
    }]
  })(props);
};
FiMessageCircle.displayName = "FiMessageCircle";
export var FiMessageSquare = function FiMessageSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
      }
    }]
  })(props);
};
FiMessageSquare.displayName = "FiMessageSquare";
export var FiMicOff = function FiMicOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "23",
        "x2": "16",
        "y2": "23"
      }
    }]
  })(props);
};
FiMicOff.displayName = "FiMicOff";
export var FiMic = function FiMic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10v2a7 7 0 0 1-14 0v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "23",
        "x2": "16",
        "y2": "23"
      }
    }]
  })(props);
};
FiMic.displayName = "FiMic";
export var FiMinimize2 = function FiMinimize2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "4 14 10 14 10 20"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "20 10 14 10 14 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "10",
        "y2": "14"
      }
    }]
  })(props);
};
FiMinimize2.displayName = "FiMinimize2";
export var FiMinimize = function FiMinimize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
      }
    }]
  })(props);
};
FiMinimize.displayName = "FiMinimize";
export var FiMinusCircle = function FiMinusCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiMinusCircle.displayName = "FiMinusCircle";
export var FiMinusSquare = function FiMinusSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiMinusSquare.displayName = "FiMinusSquare";
export var FiMinus = function FiMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
};
FiMinus.displayName = "FiMinus";
export var FiMonitor = function FiMonitor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "3",
        "width": "20",
        "height": "14",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
};
FiMonitor.displayName = "FiMonitor";
export var FiMoon = function FiMoon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      }
    }]
  })(props);
};
FiMoon.displayName = "FiMoon";
export var FiMoreHorizontal = function FiMoreHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
};
FiMoreHorizontal.displayName = "FiMoreHorizontal";
export var FiMoreVertical = function FiMoreVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
};
FiMoreVertical.displayName = "FiMoreVertical";
export var FiMove = function FiMove(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "5 9 2 12 5 15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 5 12 2 15 5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 19 12 22 9 19"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "19 9 22 12 19 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "12",
        "x2": "22",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "22"
      }
    }]
  })(props);
};
FiMove.displayName = "FiMove";
export var FiMusic = function FiMusic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M9 17H5a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm12-2h-4a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 17 9 5 21 3 21 15"
      }
    }]
  })(props);
};
FiMusic.displayName = "FiMusic";
export var FiNavigation2 = function FiNavigation2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "12 2 19 21 12 17 5 21 12 2"
      }
    }]
  })(props);
};
FiNavigation2.displayName = "FiNavigation2";
export var FiNavigation = function FiNavigation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "3 11 22 2 13 21 11 13 3 11"
      }
    }]
  })(props);
};
FiNavigation.displayName = "FiNavigation";
export var FiOctagon = function FiOctagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
      }
    }]
  })(props);
};
FiOctagon.displayName = "FiOctagon";
export var FiPackage = function FiPackage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "2.32 6.16 12 11 21.68 6.16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "22.76",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "3.5",
        "x2": "17",
        "y2": "8.5"
      }
    }]
  })(props);
};
FiPackage.displayName = "FiPackage";
export var FiPaperclip = function FiPaperclip(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
      }
    }]
  })(props);
};
FiPaperclip.displayName = "FiPaperclip";
export var FiPauseCircle = function FiPauseCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "15",
        "x2": "10",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "15",
        "x2": "14",
        "y2": "9"
      }
    }]
  })(props);
};
FiPauseCircle.displayName = "FiPauseCircle";
export var FiPause = function FiPause(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "4",
        "width": "4",
        "height": "16"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "4",
        "height": "16"
      }
    }]
  })(props);
};
FiPause.displayName = "FiPause";
export var FiPercent = function FiPercent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "5",
        "y2": "19"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "6.5",
        "r": "2.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }]
  })(props);
};
FiPercent.displayName = "FiPercent";
export var FiPhoneCall = function FiPhoneCall(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhoneCall.displayName = "FiPhoneCall";
export var FiPhoneForwarded = function FiPhoneForwarded(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "19 1 23 5 19 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "5",
        "x2": "23",
        "y2": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhoneForwarded.displayName = "FiPhoneForwarded";
export var FiPhoneIncoming = function FiPhoneIncoming(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "16 2 16 8 22 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "1",
        "x2": "16",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhoneIncoming.displayName = "FiPhoneIncoming";
export var FiPhoneMissed = function FiPhoneMissed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "1",
        "x2": "17",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "1",
        "x2": "23",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhoneMissed.displayName = "FiPhoneMissed";
export var FiPhoneOff = function FiPhoneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "1",
        "x2": "1",
        "y2": "23"
      }
    }]
  })(props);
};
FiPhoneOff.displayName = "FiPhoneOff";
export var FiPhoneOutgoing = function FiPhoneOutgoing(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 7 23 1 17 1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "8",
        "x2": "23",
        "y2": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhoneOutgoing.displayName = "FiPhoneOutgoing";
export var FiPhone = function FiPhone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(props);
};
FiPhone.displayName = "FiPhone";
export var FiPieChart = function FiPieChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12A10 10 0 0 0 12 2v10z"
      }
    }]
  })(props);
};
FiPieChart.displayName = "FiPieChart";
export var FiPlayCircle = function FiPlayCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "10 8 16 12 10 16 10 8"
      }
    }]
  })(props);
};
FiPlayCircle.displayName = "FiPlayCircle";
export var FiPlay = function FiPlay(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "5 3 19 12 5 21 5 3"
      }
    }]
  })(props);
};
FiPlay.displayName = "FiPlay";
export var FiPlusCircle = function FiPlusCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiPlusCircle.displayName = "FiPlusCircle";
export var FiPlusSquare = function FiPlusSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
};
FiPlusSquare.displayName = "FiPlusSquare";
export var FiPlus = function FiPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
};
FiPlus.displayName = "FiPlus";
export var FiPocket = function FiPocket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 10 12 14 16 10"
      }
    }]
  })(props);
};
FiPocket.displayName = "FiPocket";
export var FiPower = function FiPower(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18.36 6.64a9 9 0 1 1-12.73 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "12"
      }
    }]
  })(props);
};
FiPower.displayName = "FiPower";
export var FiPrinter = function FiPrinter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "6 9 6 2 18 2 18 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "14",
        "width": "12",
        "height": "8"
      }
    }]
  })(props);
};
FiPrinter.displayName = "FiPrinter";
export var FiRadio = function FiRadio(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
      }
    }]
  })(props);
};
FiRadio.displayName = "FiRadio";
export var FiRefreshCcw = function FiRefreshCcw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "1 4 1 10 7 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "23 20 23 14 17 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
      }
    }]
  })(props);
};
FiRefreshCcw.displayName = "FiRefreshCcw";
export var FiRefreshCw = function FiRefreshCw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 4 23 10 17 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "1 20 1 14 7 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
      }
    }]
  })(props);
};
FiRefreshCw.displayName = "FiRefreshCw";
export var FiRepeat = function FiRepeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "17 1 21 5 17 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11V9a4 4 0 0 1 4-4h14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 23 3 19 7 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 13v2a4 4 0 0 1-4 4H3"
      }
    }]
  })(props);
};
FiRepeat.displayName = "FiRepeat";
export var FiRewind = function FiRewind(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "11 19 2 12 11 5 11 19"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "22 19 13 12 22 5 22 19"
      }
    }]
  })(props);
};
FiRewind.displayName = "FiRewind";
export var FiRotateCcw = function FiRotateCcw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "1 4 1 10 7 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
      }
    }]
  })(props);
};
FiRotateCcw.displayName = "FiRotateCcw";
export var FiRotateCw = function FiRotateCw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 4 23 10 17 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
      }
    }]
  })(props);
};
FiRotateCw.displayName = "FiRotateCw";
export var FiRss = function FiRss(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 11a9 9 0 0 1 9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4a16 16 0 0 1 16 16"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
};
FiRss.displayName = "FiRss";
export var FiSave = function FiSave(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 21 17 13 7 13 7 21"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 3 7 8 15 8"
      }
    }]
  })(props);
};
FiSave.displayName = "FiSave";
export var FiScissors = function FiScissors(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "8.12",
        "y2": "15.88"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.47",
        "y1": "14.48",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.12",
        "y1": "8.12",
        "x2": "12",
        "y2": "12"
      }
    }]
  })(props);
};
FiScissors.displayName = "FiScissors";
export var FiSearch = function FiSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }]
  })(props);
};
FiSearch.displayName = "FiSearch";
export var FiSend = function FiSend(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "22",
        "y1": "2",
        "x2": "11",
        "y2": "13"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "22 2 15 22 11 13 2 9 22 2"
      }
    }]
  })(props);
};
FiSend.displayName = "FiSend";
export var FiServer = function FiServer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "2",
        "width": "20",
        "height": "8",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "14",
        "width": "20",
        "height": "8",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "6",
        "x2": "6",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "18"
      }
    }]
  })(props);
};
FiServer.displayName = "FiServer";
export var FiSettings = function FiSettings(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
      }
    }]
  })(props);
};
FiSettings.displayName = "FiSettings";
export var FiShare2 = function FiShare2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "5",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "19",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.59",
        "y1": "13.51",
        "x2": "15.42",
        "y2": "17.49"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15.41",
        "y1": "6.51",
        "x2": "8.59",
        "y2": "10.49"
      }
    }]
  })(props);
};
FiShare2.displayName = "FiShare2";
export var FiShare = function FiShare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 6 12 2 8 6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
};
FiShare.displayName = "FiShare";
export var FiShieldOff = function FiShieldOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiShieldOff.displayName = "FiShieldOff";
export var FiShield = function FiShield(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      }
    }]
  })(props);
};
FiShield.displayName = "FiShield";
export var FiShoppingBag = function FiShoppingBag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10a4 4 0 0 1-8 0"
      }
    }]
  })(props);
};
FiShoppingBag.displayName = "FiShoppingBag";
export var FiShoppingCart = function FiShoppingCart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "21",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "21",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
      }
    }]
  })(props);
};
FiShoppingCart.displayName = "FiShoppingCart";
export var FiShuffle = function FiShuffle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "16 3 21 3 21 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "21 16 21 21 16 21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "15",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "9",
        "y2": "9"
      }
    }]
  })(props);
};
FiShuffle.displayName = "FiShuffle";
export var FiSidebar = function FiSidebar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "3",
        "x2": "9",
        "y2": "21"
      }
    }]
  })(props);
};
FiSidebar.displayName = "FiSidebar";
export var FiSkipBack = function FiSkipBack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "19 20 9 12 19 4 19 20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "19",
        "x2": "5",
        "y2": "5"
      }
    }]
  })(props);
};
FiSkipBack.displayName = "FiSkipBack";
export var FiSkipForward = function FiSkipForward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "5 4 15 12 5 20 5 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "19",
        "y2": "19"
      }
    }]
  })(props);
};
FiSkipForward.displayName = "FiSkipForward";
export var FiSlack = function FiSlack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22.08 9C19.81 1.41 16.54-.35 9 1.92S-.35 7.46 1.92 15 7.46 24.35 15 22.08 24.35 16.54 22.08 9z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12.57",
        "y1": "5.99",
        "x2": "16.15",
        "y2": "16.39"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.85",
        "y1": "7.61",
        "x2": "11.43",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.39",
        "y1": "7.85",
        "x2": "5.99",
        "y2": "11.43"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.01",
        "y1": "12.57",
        "x2": "7.61",
        "y2": "16.15"
      }
    }]
  })(props);
};
FiSlack.displayName = "FiSlack";
export var FiSlash = function FiSlash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "19.07",
        "y2": "19.07"
      }
    }]
  })(props);
};
FiSlash.displayName = "FiSlash";
export var FiSliders = function FiSliders(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "21",
        "x2": "4",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "4",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "21",
        "x2": "20",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "14",
        "x2": "7",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "15",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "16",
        "x2": "23",
        "y2": "16"
      }
    }]
  })(props);
};
FiSliders.displayName = "FiSliders";
export var FiSmartphone = function FiSmartphone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "2",
        "width": "14",
        "height": "20",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "18"
      }
    }]
  })(props);
};
FiSmartphone.displayName = "FiSmartphone";
export var FiSpeaker = function FiSpeaker(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "2",
        "width": "16",
        "height": "20",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "6"
      }
    }]
  })(props);
};
FiSpeaker.displayName = "FiSpeaker";
export var FiSquare = function FiSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }]
  })(props);
};
FiSquare.displayName = "FiSquare";
export var FiStar = function FiStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
      }
    }]
  })(props);
};
FiStar.displayName = "FiStar";
export var FiStopCircle = function FiStopCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "9",
        "width": "6",
        "height": "6"
      }
    }]
  })(props);
};
FiStopCircle.displayName = "FiStopCircle";
export var FiSun = function FiSun(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "1",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "23"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.22",
        "y1": "4.22",
        "x2": "5.64",
        "y2": "5.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.36",
        "y1": "18.36",
        "x2": "19.78",
        "y2": "19.78"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "23",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.22",
        "y1": "19.78",
        "x2": "5.64",
        "y2": "18.36"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.36",
        "y1": "5.64",
        "x2": "19.78",
        "y2": "4.22"
      }
    }]
  })(props);
};
FiSun.displayName = "FiSun";
export var FiSunrise = function FiSunrise(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17 18a5 5 0 0 0-10 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.22",
        "y1": "10.22",
        "x2": "5.64",
        "y2": "11.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "18",
        "x2": "3",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "18",
        "x2": "23",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.36",
        "y1": "11.64",
        "x2": "19.78",
        "y2": "10.22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "22",
        "x2": "1",
        "y2": "22"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 6 12 2 16 6"
      }
    }]
  })(props);
};
FiSunrise.displayName = "FiSunrise";
export var FiSunset = function FiSunset(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17 18a5 5 0 0 0-10 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.22",
        "y1": "10.22",
        "x2": "5.64",
        "y2": "11.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "18",
        "x2": "3",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "18",
        "x2": "23",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.36",
        "y1": "11.64",
        "x2": "19.78",
        "y2": "10.22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "22",
        "x2": "1",
        "y2": "22"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 5 12 9 8 5"
      }
    }]
  })(props);
};
FiSunset.displayName = "FiSunset";
export var FiTablet = function FiTablet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "2",
        "width": "16",
        "height": "20",
        "rx": "2",
        "ry": "2",
        "transform": "rotate(180 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "18"
      }
    }]
  })(props);
};
FiTablet.displayName = "FiTablet";
export var FiTag = function FiTag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "7",
        "y2": "7"
      }
    }]
  })(props);
};
FiTag.displayName = "FiTag";
export var FiTarget = function FiTarget(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }]
  })(props);
};
FiTarget.displayName = "FiTarget";
export var FiTerminal = function FiTerminal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "4 17 10 11 4 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
};
FiTerminal.displayName = "FiTerminal";
export var FiThermometer = function FiThermometer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
      }
    }]
  })(props);
};
FiThermometer.displayName = "FiThermometer";
export var FiThumbsDown = function FiThumbsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
      }
    }]
  })(props);
};
FiThumbsDown.displayName = "FiThumbsDown";
export var FiThumbsUp = function FiThumbsUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
      }
    }]
  })(props);
};
FiThumbsUp.displayName = "FiThumbsUp";
export var FiToggleLeft = function FiToggleLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "5",
        "width": "22",
        "height": "14",
        "rx": "7",
        "ry": "7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
};
FiToggleLeft.displayName = "FiToggleLeft";
export var FiToggleRight = function FiToggleRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "5",
        "width": "22",
        "height": "14",
        "rx": "7",
        "ry": "7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
};
FiToggleRight.displayName = "FiToggleRight";
export var FiTrash2 = function FiTrash2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "3 6 5 6 21 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "11",
        "x2": "14",
        "y2": "17"
      }
    }]
  })(props);
};
FiTrash2.displayName = "FiTrash2";
export var FiTrash = function FiTrash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "3 6 5 6 21 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }]
  })(props);
};
FiTrash.displayName = "FiTrash";
export var FiTrendingDown = function FiTrendingDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 18 13.5 8.5 8.5 13.5 1 6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 18 23 18 23 12"
      }
    }]
  })(props);
};
FiTrendingDown.displayName = "FiTrendingDown";
export var FiTrendingUp = function FiTrendingUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 6 13.5 15.5 8.5 10.5 1 18"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 6 23 6 23 12"
      }
    }]
  })(props);
};
FiTrendingUp.displayName = "FiTrendingUp";
export var FiTriangle = function FiTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      }
    }]
  })(props);
};
FiTriangle.displayName = "FiTriangle";
export var FiTruck = function FiTruck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "3",
        "width": "15",
        "height": "13"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "16 8 20 8 23 11 23 16 16 16 16 8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5.5",
        "cy": "18.5",
        "r": "2.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18.5",
        "cy": "18.5",
        "r": "2.5"
      }
    }]
  })(props);
};
FiTruck.displayName = "FiTruck";
export var FiTv = function FiTv(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "15",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 2 12 7 7 2"
      }
    }]
  })(props);
};
FiTv.displayName = "FiTv";
export var FiTwitter = function FiTwitter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
      }
    }]
  })(props);
};
FiTwitter.displayName = "FiTwitter";
export var FiType = function FiType(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "4 7 4 4 20 4 20 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "20",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
};
FiType.displayName = "FiType";
export var FiUmbrella = function FiUmbrella(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
      }
    }]
  })(props);
};
FiUmbrella.displayName = "FiUmbrella";
export var FiUnderline = function FiUnderline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "21",
        "x2": "20",
        "y2": "21"
      }
    }]
  })(props);
};
FiUnderline.displayName = "FiUnderline";
export var FiUnlock = function FiUnlock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "11",
        "width": "18",
        "height": "11",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11V7a5 5 0 0 1 9.9-1"
      }
    }]
  })(props);
};
FiUnlock.displayName = "FiUnlock";
export var FiUploadCloud = function FiUploadCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "16 16 12 12 8 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 16 12 12 8 16"
      }
    }]
  })(props);
};
FiUploadCloud.displayName = "FiUploadCloud";
export var FiUpload = function FiUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 8 12 3 7 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
};
FiUpload.displayName = "FiUpload";
export var FiUserCheck = function FiUserCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 11 19 13 23 9"
      }
    }]
  })(props);
};
FiUserCheck.displayName = "FiUserCheck";
export var FiUserMinus = function FiUserMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "11",
        "x2": "17",
        "y2": "11"
      }
    }]
  })(props);
};
FiUserMinus.displayName = "FiUserMinus";
export var FiUserPlus = function FiUserPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "11",
        "x2": "17",
        "y2": "11"
      }
    }]
  })(props);
};
FiUserPlus.displayName = "FiUserPlus";
export var FiUserX = function FiUserX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "8",
        "x2": "23",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "8",
        "x2": "18",
        "y2": "13"
      }
    }]
  })(props);
};
FiUserX.displayName = "FiUserX";
export var FiUser = function FiUser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }]
  })(props);
};
FiUser.displayName = "FiUser";
export var FiUsers = function FiUsers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M23 21v-2a4 4 0 0 0-3-3.87"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3.13a4 4 0 0 1 0 7.75"
      }
    }]
  })(props);
};
FiUsers.displayName = "FiUsers";
export var FiVideoOff = function FiVideoOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiVideoOff.displayName = "FiVideoOff";
export var FiVideo = function FiVideo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "23 7 16 12 23 17 23 7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "1",
        "y": "5",
        "width": "15",
        "height": "14",
        "rx": "2",
        "ry": "2"
      }
    }]
  })(props);
};
FiVideo.displayName = "FiVideo";
export var FiVoicemail = function FiVoicemail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "5.5",
        "cy": "11.5",
        "r": "4.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18.5",
        "cy": "11.5",
        "r": "4.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.5",
        "y1": "16",
        "x2": "18.5",
        "y2": "16"
      }
    }]
  })(props);
};
FiVoicemail.displayName = "FiVoicemail";
export var FiVolume1 = function FiVolume1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
      }
    }]
  })(props);
};
FiVolume1.displayName = "FiVolume1";
export var FiVolume2 = function FiVolume2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
      }
    }]
  })(props);
};
FiVolume2.displayName = "FiVolume2";
export var FiVolumeX = function FiVolumeX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "9",
        "x2": "17",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "9",
        "x2": "23",
        "y2": "15"
      }
    }]
  })(props);
};
FiVolumeX.displayName = "FiVolumeX";
export var FiVolume = function FiVolume(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
      }
    }]
  })(props);
};
FiVolume.displayName = "FiVolume";
export var FiWatch = function FiWatch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 9 12 12 13.5 13.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
      }
    }]
  })(props);
};
FiWatch.displayName = "FiWatch";
export var FiWifiOff = function FiWifiOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.71 5.05A16 16 0 0 1 22.58 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
};
FiWifiOff.displayName = "FiWifiOff";
export var FiWifi = function FiWifi(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M5 12.55a11 11 0 0 1 14.08 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M1.42 9a16 16 0 0 1 21.16 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
};
FiWifi.displayName = "FiWifi";
export var FiWind = function FiWind(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
      }
    }]
  })(props);
};
FiWind.displayName = "FiWind";
export var FiXCircle = function FiXCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
};
FiXCircle.displayName = "FiXCircle";
export var FiXSquare = function FiXSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }]
  })(props);
};
FiXSquare.displayName = "FiXSquare";
export var FiX = function FiX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "6",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
};
FiX.displayName = "FiX";
export var FiYoutube = function FiYoutube(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
      }
    }]
  })(props);
};
FiYoutube.displayName = "FiYoutube";
export var FiZapOff = function FiZapOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "12.41 6.75 13 2 10.57 4.92"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "18.57 12.91 21 10 15.66 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 8 3 14 12 14 11 22 16 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
};
FiZapOff.displayName = "FiZapOff";
export var FiZap = function FiZap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
      }
    }]
  })(props);
};
FiZap.displayName = "FiZap";
export var FiZoomIn = function FiZoomIn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "8",
        "x2": "11",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }]
  })(props);
};
FiZoomIn.displayName = "FiZoomIn";
export var FiZoomOut = function FiZoomOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }]
  })(props);
};
FiZoomOut.displayName = "FiZoomOut";